import { FC } from "react"
import { FieldProps } from "@rjsf/core"
import { TableColumn, TextInput } from "resha"
import { Markdown, Title } from "dash-styled"
import { ArrayAsTableBase } from "./ArrayAsTableBase"

export const TextArrayField: FC<FieldProps<string[] | undefined>> =
    fieldProps => {
        const {
            formData = [],
            onChange,
            uiSchema,
            schema: { title, description }
        } = fieldProps

        const handleChange = (index: number) => (value: string) => {
            const newValue = [...formData]
            newValue[index] = value
            onChange(newValue)
        }

        const columns: TableColumn<string>[] = [
            {
                className: () => "pl-2 bg-white border-b-rhino-300",
                renderHeader: () => null,
                headerClassName: "hidden",
                render: (value, isChecked, rowIndex) => {
                    return (
                        <TextInput
                            value={value}
                            enableCopyTextButton={false}
                            enableMarkdown={false}
                            onValueChange={handleChange(rowIndex)}
                            inputClassName="rounded-lg bg-transparent text-sm leading-5 py-2 px-3"
                            className="rounded-lg border border-rhino-300"
                        />
                    )
                }
            }
        ]
        return (
            <>
                {title && (
                    <Title variant="heading4" className="mb-1">
                        {title}
                    </Title>
                )}
                {description && (
                    <Markdown
                        className="text-sm text-smoke-500 mb-1"
                        text={description}
                    />
                )}
                <ArrayAsTableBase<string>
                    values={formData}
                    onChange={onChange}
                    internalColumns={columns}
                    defaultValue=""
                    addButtonLabel={
                        uiSchema["ui:options"]?.addButtonLabel as string
                    }
                />
            </>
        )
    }
